const d=(d,a)=>{var o;(null===(o=null===window||void 0===window?void 0:window.magaluads)||void 0===o?void 0:o.track)&&a.ad_id&&window.magaluads.track(d,a)};export{d as default};
